import React from "react";
import { SelectDateAndTimeScreenWithBookingData } from "~/features/book-appointment/SelectDateAndTimeScreen";

const Component = () => {
  return <SelectDateAndTimeScreenWithBookingData />;
};

export default Component;
